exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-877d6f5a] .templateList .el-form-item__label {\n  font-weight: 700;\n}\n[data-v-877d6f5a] .richText {\n  width: 80%;\n  line-height: 20px;\n}\n[data-v-877d6f5a] .richText * {\n  margin: 0;\n  line-height: 20px;\n}", ""]);

// exports
